"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = _interopRequireDefault(require("@kyruus/button"));
var _formsV = require("@kyruus/forms-v2");
var _styles = require("./styles");
const getDisclaimer = (disclaimer, handleTrack) => {
  if (typeof disclaimer === 'string') {
    return /*#__PURE__*/_react.default.createElement("p", null, disclaimer);
  }
  /* footer disclaimer can be configured the same as a form field "add on" 
  which supports a modal link */
  if ((0, _some.default)(disclaimer).call(disclaimer, disc => disc.sentence)) {
    return /*#__PURE__*/_react.default.createElement(_formsV.AddOn, {
      onTrack: handleTrack,
      addOnType: "disclaimer",
      content: disclaimer
    });
  }
  return (0, _map.default)(disclaimer).call(disclaimer, paragraph => /*#__PURE__*/_react.default.createElement("p", {
    key: paragraph
  }, paragraph));
};
function RegFormFooterContent(_ref) {
  let {
    handleSubmit,
    disclaimer,
    handleTrack
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.NextBtnContainer, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-testid": "NextBtn",
    mode: "primary",
    onClick: handleSubmit
  }, "Next")), disclaimer.length ? /*#__PURE__*/_react.default.createElement(_styles.DisclaimerContainer, {
    "data-testId": "disclaimer-container"
  }, getDisclaimer(disclaimer, handleTrack)) : null);
}
RegFormFooterContent.defaultProps = {
  disclaimer: [],
  handleTrack: () => {}
};
RegFormFooterContent.propTypes = {
  handleSubmit: _propTypes.default.func.isRequired,
  disclaimer: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.shape({
    sentence: _propTypes.default.string,
    hasModal: _propTypes.default.bool,
    modalContent: _propTypes.default.shape({
      title: _propTypes.default.string,
      body: _propTypes.default.arrayOf(_propTypes.default.string)
    })
  })]),
  handleTrack: _propTypes.default.func
};
var _default = exports.default = RegFormFooterContent;
RegFormFooterContent.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RegFormFooterContent",
  "props": {
    "disclaimer": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }, {
          "name": "shape",
          "value": {
            "sentence": {
              "name": "string",
              "required": false
            },
            "hasModal": {
              "name": "bool",
              "required": false
            },
            "modalContent": {
              "name": "shape",
              "value": {
                "title": {
                  "name": "string",
                  "required": false
                },
                "body": {
                  "name": "arrayOf",
                  "value": {
                    "name": "string"
                  },
                  "required": false
                }
              },
              "required": false
            }
          }
        }]
      },
      "required": false
    },
    "handleTrack": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "handleSubmit": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};